/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_age_wd_saturday = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saturday`)
};

const es_age_wd_saturday = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sábado`)
};

const de_age_wd_saturday = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samstag`)
};

const nl_age_wd_saturday = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaterdag`)
};

const fr_age_wd_saturday = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samedi`)
};

const it_age_wd_saturday = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sabato`)
};

const pt_br2_age_wd_saturday = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sábado`)
};

const pt_age_wd_saturday = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sábado`)
};

const ja_age_wd_saturday = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`土曜日`)
};

const zh_age_wd_saturday = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`星期六`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const age_wd_saturday = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.age_wd_saturday(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("age_wd_saturday", locale)
	if (locale === "en") return en_age_wd_saturday(inputs)
	if (locale === "es") return es_age_wd_saturday(inputs)
	if (locale === "de") return de_age_wd_saturday(inputs)
	if (locale === "nl") return nl_age_wd_saturday(inputs)
	if (locale === "fr") return fr_age_wd_saturday(inputs)
	if (locale === "it") return it_age_wd_saturday(inputs)
	if (locale === "pt-BR") return pt_br2_age_wd_saturday(inputs)
	if (locale === "pt") return pt_age_wd_saturday(inputs)
	if (locale === "ja") return ja_age_wd_saturday(inputs)
	return zh_age_wd_saturday(inputs)
};